import { Box } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useEffect, useState } from "react"
import { m } from "framer-motion"

export function TaskRunningMan() {
    const [frame, setFrame] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setFrame((f) => (f === 0 ? 1 : 0))
        }, 300)

        return () => clearInterval(interval)
    }, [])

    return (
        <Box
            flexGrow={1}
            component={m.span}
            initial={{ x: 0, opacity: 0.1 }}
            animate={{ x: "100%", opacity: [0, 1, 1, 1, 0] }}
            transition={{
                duration: 10,
                ease: "linear",
                repeat: Infinity,
            }}
            sx={{ width: "100%" }}
        >
            {frame === 0 ? <Iconify icon="fa-solid:running" /> : <Iconify icon="fa-solid:walking" />}{" "}
        </Box>
    )
}
